import React, { useEffect, useState } from 'react';
import { Menu, X, CalendarDays, LogIn } from 'lucide-react';
import PreventiAppLogo from './PreventiAppLogo';
import { trackNav } from '../lib/tracking';
import { openDemoRequest } from '../lib/demoRequest';
import { goToApp, APP_URL } from '../lib/smartAccess';

const links = [
  { id: 'inicio', label: 'Inicio' },
  { id: 'problema', label: 'Problema' },
  { id: 'beneficios', label: 'Beneficios' },
  { id: 'como-funciona', label: 'Cómo funciona' },
  { id: 'piloto', label: 'Piloto' },
  { id: 'contacto', label: 'Contacto' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    trackNav(id, { from: 'navbar' });
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? 'nav-blur' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go('inicio')}
          className="flex items-center gap-2 group"
          aria-label="Ir al inicio"
        >
          <PreventiAppLogo className="h-9 sm:h-10 w-auto" />
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="px-3 py-2 text-sm font-semibold text-brand-deep/80 hover:text-brand-violet transition-colors rounded-lg hover:bg-brand-light"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2">
          <button
            data-testid="nav-cta-demo"
            onClick={() => openDemoRequest('header')}
            className="btn-primary px-5 py-2.5 rounded-full text-sm font-semibold inline-flex items-center gap-2"
          >
            <CalendarDays className="w-4 h-4" />
            Solicitar Demo
          </button>
          <button
            type="button"
            data-testid="nav-cta-acceder"
            onClick={() => goToApp('header')}
            className="px-5 py-2.5 rounded-full text-sm font-bold inline-flex items-center gap-2 text-white transition-all hover:brightness-110 hover:-translate-y-[1px]"
            style={{ background: '#0B1B5E', boxShadow: '0 12px 24px -12px rgba(11,27,94,0.55)' }}
          >
            <LogIn className="w-4 h-4" />
            ACCEDER
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden p-2 rounded-lg text-brand-deep hover:bg-brand-light"
          onClick={() => setOpen((v) => !v)}
          aria-label="Abrir menú"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-panel" className="lg:hidden bg-white border-t border-brand">
          <div className="max-w-7xl mx-auto px-5 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-link-mobile-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left px-4 py-3 rounded-xl text-base font-semibold text-brand-deep hover:bg-brand-light"
              >
                {l.label}
              </button>
            ))}
            <button
              type="button"
              data-testid="nav-cta-demo-mobile"
              onClick={() => { setOpen(false); openDemoRequest('header'); }}
              className="btn-primary px-4 py-3 rounded-full text-sm font-semibold inline-flex items-center justify-center gap-2 w-full mt-2"
            >
              <CalendarDays className="w-4 h-4" />
              Solicitar Demo
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
